import { Box, Divider, Grid, Modal, Typography } from "@mui/material";
import React from "react";

const DisApproveModal = ({
  disApproveModal,
  setDisApproveModal,
  handleControl,
  setRejectedReason,
  error,
  rejectedReason,
}) => {
  return (
    <Modal
      open={disApproveModal}
      onClose={() => setDisApproveModal(!disApproveModal)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 600,
          height: 380,
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: "12px",
        }}
      >
        <Box display={"flex"} justifyContent={"space-between"} px={3} py={2}>
          <Typography fontSize={"18px"} fontWeight={600} color={"#2E2E2E"}>
            Not approved?
          </Typography>
          <Box
            component={"div"}
            style={{
              cursor: "pointer",
            }}
            onClick={() => setDisApproveModal(!disApproveModal)}
          >
            +
          </Box>
        </Box>
        <Divider variant="fullWidth" />

        <Typography
          fontSize={"14px"}
          margin={3}
          color={"#2E2E2E"}
          fontWeight={500}
        >
          Add Reason
        </Typography>
        <Box
          border={"solid 1px  #D8E3F1"}
          margin={`10px 22px`}
          borderRadius={"10px"}
        >
          <textarea
            placeholder="Your text here"
            type="text"
            rows="4" // You can set the number of rows to determine the initial size
            cols="50"
            style={{
              margin: 4,
              width: "98%",
              height: "100px",

              flex: "1",
              border: "none",
              outline: "none",
            }}
            onChange={(e) => setRejectedReason(e?.target?.value)}
          />
        </Box>
        <Grid sx={{height:"40px"}}>
          {rejectedReason === "" && error && (
            <Typography
              sx={{ color: "red", paddingLeft: "25px", paddingBottom: "10px" }}
            >
              Please enter your reason
            </Typography>
          )}
        </Grid>

        <Divider variant="fullWidth" />
        <Box display={"flex"} gap={2} justifyContent={"end"} padding={2}>
          <Box
            component={"button"}
            onClick={() => setDisApproveModal(!disApproveModal)}
            width={"100px"}
            p={"15px"}
            textAlign={"center"}
            borderRadius={2}
            border={"solid 1px #4C5A6A"}
            bgcolor={"#FFFFFF"}
            style={{
              cursor: "pointer",
            }}
          >
            Cancel
          </Box>
          <Box
            component={"button"}
            bgcolor={"#17DFBA"}
            width={"100px"}
            p={"15px"}
            textAlign={"center"}
            borderRadius={2}
            border={"none"}
            style={{
              cursor: "pointer",
            }}
            onClick={()=>handleControl("REJECTED")}
          >
            Send
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default DisApproveModal;
